import { CommonActionType } from './action.type';

export const CommonActions = {
    async [CommonActionType.SetExchangeRate]({commit}, rate) {
        commit(CommonActionType.SetExchangeRate, rate);
    },

    async [CommonActionType.SetMinFeeBuy]({commit}, minFeeBuy) {
        commit(CommonActionType.SetMinFeeBuy, minFeeBuy);
    },

    async [CommonActionType.FeeBuyPro]({commit}, feeBuyPro) {
        commit(CommonActionType.FeeBuyPro, feeBuyPro);
    },

    async [CommonActionType.SetCustomerLevels]({commit}, customerLevels) {
        commit(CommonActionType.SetCustomerLevels, customerLevels);
    },

    async [CommonActionType.SetWarehouse]({commit}, warehouse) {
        commit(CommonActionType.SetWarehouse, warehouse);
    },
    
    async [CommonActionType.SetShippingMethod]({commit}, shippingMethod) {
        commit(CommonActionType.SetShippingMethod, shippingMethod);
    },

    async [CommonActionType.ShowHideMenuLeft]({commit}, isShowMenuLeft) {
        commit(CommonActionType.ShowHideMenuLeft, isShowMenuLeft);
    }
};

